export const rememberOrderPaymentAccess = (order: { id: number; payment_access_token?: string | null }) => {
  if (typeof window === 'undefined' || !order.payment_access_token) return
  try { sessionStorage.setItem(`order-payment:${order.id}`, order.payment_access_token) } catch { /* Browser storage may be disabled. */ }
}

export const orderPaymentHeaders = (orderId: number): Record<string, string> => {
  if (typeof window === 'undefined') return {}
  try {
    const token = sessionStorage.getItem(`order-payment:${orderId}`)
    return token ? { 'X-Order-Payment-Token': token } : {}
  } catch { return {} }
}
